import { Methods } from '@api/shop/list';
import { Request } from '../../request';
export default async (query:Methods["get"]["query"]) => Request( client => client.shop.list.$get({query}) )
